/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { registerRefreshQueryClient } from 'src/store/auth/refreshAccessToken';

import useAuth from '@hooks/useAuth';
import { useQueryClient } from '@tanstack/react-query';

import { AuthPage, Logout } from './modules/Auth';
import BasePage from './BasePage';

import { Layout } from '_metronic/layout';

export function Routes() {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const isAuthorized = !!auth;

  // The query cache only exists inside `BackofficeProvider`; register it here (a
  // descendant of it) so the reactive refresh-on-401 interceptor (attached in
  // AppApiClient) can clear it on a failed refresh.
  useEffect(() => {
    registerRefreshQueryClient(queryClient);
  }, [queryClient]);

  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route component={Logout} path="/logout" />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
  );
}
